import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { productColumns } from "../../datatablesource";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProducts } from "../../actions/fetchData";
import { CircularProgress } from "@mui/material";
import { deleteProduct } from "../../actions/deleteData";

const Datatable = ({type}) => {
  const location = useLocation()
  const dispatch = useDispatch()
  const columns = productColumns
  const [data, setData] = useState([]);
  const { products, isLoading, count} = useSelector((state)=>state.products)

  useEffect(()=>{
    !products.length && dispatch(getProducts())
  },[location])
  

  useEffect(()=>{
    products?.forEach((p)=>{
      p["id"]=p["_id"]
    })
    !data.length && setData(products)
  },[isLoading])
  
  const handleDelete = (id) => {
    dispatch(deleteProduct(id))
    setData(data.filter((item) => item.id !== id));
  };


  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link to={params.row.id} style={{ textDecoration: "none" }}>
              <div className="viewButton">View</div>
            </Link>
            <div
              className="deleteButton"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];
  return (
  <>
      <div className="datatable">
      <div className="datatableTitle">
        {`${type}`}
        <Link to={`/products/new`} className="link">
          Add New
        </Link>
      </div>
    { isLoading? <CircularProgress/> :(
      <DataGrid
        className="datagrid"
        rows={data}
        columns={columns.concat(actionColumn)}
        pageSize={9}
        rowsPerPageOptions={[9]}
        checkboxSelection
      />)}
    </div>
  </>
  );
};

export default Datatable;
